  
import React from 'react';
import { List, Datagrid, TextField, DateField, Show, SimpleShowLayout } from 'react-admin';

import { Card, CardContent, Typography } from '@mui/material';
import ReactJson from 'react-json-view';
import LogsDataProvider from './LogsDataProvider';

const LogViewer = ({ record }) => {
  return (
    <Card>
      <CardContent>
        <Typography variant="h6">Log Details</Typography>
        <ReactJson 
          src={record} 
          name={null} 
          collapsed={2} 
          enableClipboard={true} 
          displayDataTypes={false} 
        />
      </CardContent>
    </Card>
  );
};

export default LogViewer;

  export const LogShow = (props) => (
    <Show {...props} title="Log Entry">
      <SimpleShowLayout>
        <TextField source="timestamp" label="Timestamp" />
        <TextField source="level" label="Level" />
        <TextField source="message" label="Message" />
        <TextField source="tenant" label="Tenant" />
        <TextField source="brand" label="Brand" />
        <LogViewer record={props.record} />
      </SimpleShowLayout>
    </Show>
  );

